import { type UniteTypeCurrency, type UniteTypeRequisiteType } from '~/generated/payoutBackend/model';
import { type CascadeQueueItem, CascadeQueueItemType, type GroupTrader } from '../model';

export const formatCascade = {
    id: (id?: string) => id ?? '',
    name: (name?: string) => name ?? '',

    currency: (currency?: UniteTypeCurrency) => {
        if (!currency) {
            return '';
        }

        return String(currency).replace('CURRENCY_', '');
    },
    requisiteType: (type?: UniteTypeRequisiteType) => {
        if (!type) {
            return '';
        }

        return String(type).replace('TYPE_', '').replaceAll('_', ' ');
    },
    period: (startAt?: string, endAt?: string) => {
        if (!startAt && !endAt) {
            return '—';
        }

        const start = startAt ? new Date(startAt).toLocaleString() : 'Не ограничено';
        const end = endAt ? new Date(endAt).toLocaleString() : 'Не ограничено';

        return `${start} — ${end}`;
    },
    amountRange: (min?: string | number, max?: string | number) => {
        if (!min && !max) {
            return '—';
        }

        const minStr = min ? String(min) : '0';
        const maxStr = max ? String(max) : '∞';

        return `${minStr} — ${maxStr}`;
    },
    groupsCount: (groups?: { length: number }) => {
        if (!groups) {
            return '0';
        }

        return String(groups.length);
    },
    queueItemTypeLabel: (type?: CascadeQueueItemType) => {
        if (type === CascadeQueueItemType.QUEUE_ITEM_TYPE_TEMPLATE) {
            return 'Шаблон';
        }

        if (type === CascadeQueueItemType.QUEUE_ITEM_TYPE_GROUP) {
            return 'Группа';
        }

        return '—';
    },
    queueItemName: (item: CascadeQueueItem) => {
        return item.group?.name?.value || item.template?.name?.value || '—';
    },
    traderNames: (traders?: GroupTrader[]) => {
        if (!traders?.length) {
            return '—';
        }

        return traders
            .map((trader) => trader.traderName?.value || trader.id?.value)
            .filter(Boolean)
            .join(', ');
    },
} as const;
